import React,{useContext,useState}  from 'react'
import axios from 'axios'

const Report = () => {
 return (
  <>
   <h2 className="text-secondary">
   I am the report family
   </h2>
  </>
 )
}

export default Report
